import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";
import CardProduct from "../components/CardProduct";
import { auth } from "../firebase";
import { FaSortAmountDown, FaSortAmountUp, FaSearch } from "react-icons/fa";

const Home = () => {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [isLoading, setIsLoading] = useState(true); // State untuk loading animasi
    const [stockData, setStockData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Memantau status login pengguna
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setIsLoggedIn(!!user);
        });

        // Mendapatkan data produk dari Firebase
        const productRef = ref(db, "products");
        onValue(productRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const productList = Object.keys(data).map((key) => ({
                    id: key,
                    ...data[key]
                }));
                setProducts(productList);
                setFilteredProducts(productList);
            }
            setIsLoading(false); // Matikan animasi loading setelah data diterima
        });

        // Fetch stock data from API
        fetch('https://api.khfy-store.com:8443/api-xl-v7/cek_stock_akrab')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                setStockData(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });

        return () => unsubscribe();
    }, []);

    // Fungsi untuk menyortir produk berdasarkan harga terendah
    const sortCheapest = () => {
        const sorted = [...filteredProducts].sort((a, b) => a.price - b.price);
        setFilteredProducts(sorted);
    };

    // Fungsi untuk menyortir produk berdasarkan harga tertinggi
    const sortMostExpensive = () => {
        const sorted = [...filteredProducts].sort((a, b) => b.price - a.price);
        setFilteredProducts(sorted);
    };

    // Fungsi untuk menangani pencarian produk
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        const filtered = products.filter((product) =>
            product.name
                .toLowerCase()
                .includes(event.target.value.toLowerCase())
        );
        setFilteredProducts(filtered);
    };

    return (
        <div className="p-4">
            {/* Animasi Loading */}
            {isLoading ? (
                <div className="flex justify-center items-center h-screen">
                    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
            ) : (
                <>
                    {/* Header Pencarian dan Tombol Sortir */}
                    <div className="flex flex-col md:flex-row justify-between items-center mb-6">
                        {/* Form Pencarian */}
                        <div className="relative w-full md:w-1/2">
                            <input
                                type="text"
                                placeholder="Cari produk..."
                                className="w-full p-3 pl-10 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                                value={searchQuery}
                                onChange={handleSearch}
                            />
                            <FaSearch className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400" />
                        </div>

                        {/* Tombol Sortir */}
                        <div className="flex space-x-4 mt-4 md:mt-0">
                            <button
                                onClick={sortCheapest}
                                className="flex items-center px-4 py-2 bg-green-500 text-white rounded-lg shadow-md hover:bg-green-600 transition-transform transform hover:scale-105"
                            >
                                <FaSortAmountDown className="mr-2" />
                                Termurah
                            </button>
                            <button
                                onClick={sortMostExpensive}
                                className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 transition-transform transform hover:scale-105"
                            >
                                <FaSortAmountUp className="mr-2" />
                                Termahal
                            </button>
                        </div>
                    </div>

                    {/* Stock Data Section */}
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold mb-4">Stock Checker</h1>
                        {loading ? (
                            <div className="flex justify-center items-center">
                                <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                            </div>
                        ) : error ? (
                            <div className="text-red-500">Error: {error.message}</div>
                        ) : (
                            <div className="bg-white p-4 rounded-lg shadow-md">
                                <p><strong>SuperBig:</strong> {stockData.data.xxl_only} tersedia</p>
                                <p><strong>SuperMini:</strong> {stockData.data.xl_only} tersedia</p>
                                <p><strong>Mini:</strong> {stockData.data.xl_no_rw} tersedia</p>
                                <p><strong>Big:</strong> {stockData.data.xl_rw} tersedia</p>
                                <p><strong>Jumbo:</strong> {stockData.data.xxl_rw} tersedia</p>
                                <p><strong>Jumbo v2:</strong> {stockData.data.xxl_rw_v2} tersedia</p>
                            </div>
                        )}
                    </div>

                    {/* Grid Produk */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
                        {filteredProducts.map((product) => (
                            <CardProduct
                                key={product.id}
                                product={product}
                                isLoggedIn={isLoggedIn}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default Home;
